import { apiCallsProfile } from "../api/calls/profile";
import { apiCallsPillars } from "../api/calls/pillarControl";
import { apiCallsParking } from "../api/calls/parking";
import { apiCallsNetworkQuality } from "../api/calls/networkQuality";
import { apiCallsProfileAdmin } from "../api/calls/profileAdmin";
import { apiCallsNetworkTester } from "../api/calls/networkTester";

export const fetchDevices = async (filters, deviceType) => {

    if (deviceType === "autonomus") {
        return await apiCallsProfile.Actions.GetDevices(filters);
    }
    else {
        return await apiCallsPillars.Actions.GetDevices(filters);
    } 
}

export const fetchNetworkQuality = async (filters) => {
    return await apiCallsNetworkQuality.Actions.NetworkQuality(filters);
}

export const fetchNetworkTester = async (filters) => {
    return await apiCallsNetworkTester.FetchDevices(filters);
}

export const getModalData = async (deviceid, deviceType) => {
    var deviceInfo = [];
    var deviceMetrics = [];
    if (deviceType === "autonomus"){
        deviceInfo = await apiCallsProfile.Actions.GetSiteParameters(deviceid);
        deviceMetrics = await apiCallsProfile.Actions.Port25(deviceid);
    }
    else if (deviceType === "pillarControl") {
        deviceInfo = await apiCallsPillars.Actions.GetSiteParameters(deviceid);
        deviceMetrics = await apiCallsPillars.Actions.Port25(deviceid);
    }
    else if (deviceType === "networkQuality") {
        deviceInfo = await apiCallsNetworkQuality.Actions.SiteInfo(deviceid);
        deviceMetrics = await apiCallsNetworkQuality.Actions.DeviceInfo(deviceid);  
    }
    else if (deviceType === "parking") {
        deviceInfo = await apiCallsParking.Actions.SiteInfo(deviceid);
        return deviceInfo;
    }
    return [deviceInfo, deviceMetrics];
}

export const getModalDataForManagement = async (deviceId, type) => {
    if (typeof type === 'undefined') return {};

    try {
        const response = await apiCallsProfileAdmin.Actions.GetSiteParams(deviceId, type);
        const { device, connections, gateway } = response.data[0];
        if (device) {
            if (connections) {
                return {
                    ...device,
                    connections
                };
            }
            return device;
        }
        return gateway || {};
    } catch (error) {
        console.error('Error fetching modal data:', error);
        return {};
    }
};


export const changeDimLevel = async (name, dimLevel, deviceType) => {
    const userConfirmed = window.confirm("Είστε σίγουρος ότι επιθυμείτε να αλλάξετε το επίπεδο του φωτισμού;");
    
    if (!userConfirmed) {
        return;
    }
    var result = {};

    if (deviceType === "autonomus"){
        result = await apiCallsProfile.Actions.SendToSelected(name, dimLevel.toString());
        
    }
    else {
        result = await apiCallsPillars.Actions.SendToSelected(name, dimLevel);
    }

    if (result.status === 200) 
        alert("Το Επίπεδο Φωτισμού άλλαξε");
    else
        alert("Αποτυχία αλλαγής επιπέδου φωτισμού");
}

export const revertDimLevel = async (name, deviceType) => {
    const userConfirmed = window.confirm("Είστε σίγουρος ότι επιθυμείτε να επαναφέρετε τη συσκευή αυτή στο πρόγραμμα;");
    
    if (!userConfirmed) {
        return;
    }

    var result = {};

    if (deviceType === "autonomus"){
        result = await apiCallsProfile.Actions.RevertToSelected(name);
    }
    else {
        result = await apiCallsPillars.Actions.RevertToSelected(name);
    }

    if (result.status === 200) 
        alert("Η επαναφορά της συσκευής στα προγράμματα ήταν επιτυχής!");
    else
        alert("Αποτυχία επαναφοράς της συσκευής στα προγράμματα");
}

export const GetParkingDevices = async (filters) => {

    const result = await apiCallsParking.Actions.GetDevices(filters);
    return result;
}

